import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";
import { StepSlice } from "@/redux/slice/stepSlice";
import { UserSlice } from "@/redux/slice/userSlice";
import { SettingsSlice } from "@/redux/slice/settingsSlice";
import { FollowSlice } from "@/redux/slice/followSlice";
import { EmojiSlice } from "@/redux/slice/emojiSlice";
import { PostSlice } from "@/redux/slice/postSlice";
import { PaginationSlice } from "@/redux/slice/paginationSlice";
import { NavigationSlice } from "./slice/navigationSlice";
import { FeedSnapshotSlice } from "@/redux/slice/feedSnapshotSlice";
import { Broadcast } from "@/redux/slice/broadcastSlice";
import { ThemeSlice } from "./slice/themeSlice";
import { WalletSlice } from "@/redux/slice/walletSlice";
import { NotificationBulletSlice } from "@/redux/slice/notificationBulletSlice";
import { TrenchesSlice } from "@/redux/slice/trenchesSlice";
import { SettingsTrenchSlice } from "./slice/settingsTrenchSlice";
import { TrenchesChatSliceV2 } from "@/redux/slice/trenchChatSliceV2";
import { TrenchesChatOperationsSlice } from "@/redux/slice/trenchesChatOperationsSlice";
import { TrenchesFeedSlice } from "@/redux/slice/trenchesFeedSlice";
import { TrenchesFeedOperationsSlice } from "@/redux/slice/trenchesFeedOperationsSlice";
import { PostDetailSlice } from "./slice/postDetailSlice";
import { NotificationsSlice } from "./slice/notificationsSlice";
import { BookmarkSlice } from "./slice/bookmarkSlice";
import { ScrollRestoreSlice } from "./slice/scrollRestoreSlice";
import { TakeSlice } from "./slice/takeSlice";
import { ListingSlice } from "./slice/listingSlice";
import { PortfolioSlice } from "./slice/portfolioSlice";
import { WalletHistorySlice } from "./slice/walletHistorySlice";
import { DropTake } from "./slice/DroptTake";
import { TakeDetailSlice } from "./slice/takeDetailSlice";
import { ProfileTakeSlice } from "./slice/profileTakeSlice";
import { CultTakeSlice } from "./slice/cultTakeSlice";
import { ProfileDataSlice } from "./slice/userProfileSlice";
import { FollowersSlice } from "./slice/followersSlice";
import { FollowingSlice } from "./slice/followingSlice";
import { ExploreSlice } from "./slice/exploreSlice";
import { PageSlice } from "./slice/pageSlice";
import { PredictionsSlice } from "./slice/predictionsSlice";
import { PredictorsSlice } from "./slice/predictorsSlice";
import { PullToRefreshSlice } from "./slice/pullToRefreshSlice";
import { StrategySlice } from "./slice/strategySlice";
import { XApeStrategySlice } from "./slice/xApeStrategySlice";
import { CombineWalletSlice } from "./slice/walletSelectionSlice";
import { SwapSlice } from "./slice/swapSlice";

const listenerMiddleware = createListenerMiddleware();

const store = configureStore({
  reducer: {
    theme: ThemeSlice.reducer,
    steps: StepSlice.reducer,
    user: UserSlice.reducer,
    settings: SettingsSlice.reducer,
    follow: FollowSlice.reducer,
    emoji: EmojiSlice.reducer,
    posts: PostSlice.reducer,
    takes: TakeSlice.reducer,
    takedetail: TakeDetailSlice.reducer,
    portfolio: PortfolioSlice.reducer,
    walletHistory: WalletHistorySlice.reducer,
    pagination: PaginationSlice.reducer,
    navigation: NavigationSlice.reducer,
    feedStateSnapshot: FeedSnapshotSlice.reducer,
    broadcast: Broadcast.reducer,
    wallet: WalletSlice.reducer,
    notificationBullet: NotificationBulletSlice.reducer,
    notifications: NotificationsSlice.reducer,
    trenches: TrenchesSlice.reducer,
    settingsTrenchSlice: SettingsTrenchSlice.reducer,
    trenchesChatSliceV2: TrenchesChatSliceV2.reducer,
    trenchesChatOperationsSlice: TrenchesChatOperationsSlice.reducer,
    postDetail: PostDetailSlice.reducer,
    bookmarks: BookmarkSlice.reducer,
    scrollRestore: ScrollRestoreSlice.reducer,
    trenchesFeedSlice: TrenchesFeedSlice.reducer,
    trenchesFeedOperationsSlice: TrenchesFeedOperationsSlice.reducer,
    droptake: DropTake.reducer,
    mylisting: ListingSlice.reducer,
    profileTakes: ProfileTakeSlice.reducer,
    cultTakes: CultTakeSlice.reducer,
    userProfile: ProfileDataSlice.reducer,
    followerList: FollowersSlice.reducer,
    followingList: FollowingSlice.reducer,
    explore: ExploreSlice.reducer,
    page: PageSlice.reducer,
    topPredictions: PredictionsSlice.reducer,
    topPredictors: PredictorsSlice.reducer,
    pulledStates: PullToRefreshSlice.reducer,
    strategies: StrategySlice.reducer,
    xApestrategies: XApeStrategySlice.reducer,
    combineWallet : CombineWalletSlice.reducer,
    swapState : SwapSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
  devTools: true,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
